const config = {
  REACT_APP_API_URL: window.__RUNTIME_CONFIG__.REACT_APP_API_URL,
  REACT_APP_TITLE: window.__RUNTIME_CONFIG__.REACT_APP_TITLE,
  REACT_APP_NAME: window.__RUNTIME_CONFIG__.REACT_APP_NAME,
};

export default config;
